var _defs, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIprshealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 154,
    height: 44.813,
    viewBox: "0 0 154 44.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 7.261,
    y1: -65.734,
    x2: 8.263,
    y2: -65.734,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1659f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c83883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a93c85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 11.024,
    y1: -68.621,
    x2: 12.023,
    y2: -68.621,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dcdf93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#bbc85f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86a433"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(-218.259 -238.204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M549.01,266.858a2.722,2.722,0,0,0-2.719,2.71v.124A2.752,2.752,0,0,0,549,272.411c1.446,0,4.527-.085,6.54,1.928s1.786,4.927,1.786,6.423a2.722,2.722,0,0,0,2.71,2.719h.124a2.723,2.723,0,0,0,2.719-2.711v-6.086c0-5.846-2.2-7.826-6.479-7.826Z",
    transform: "translate(-201.656 -17.615)",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M588.777,254.81a2.708,2.708,0,0,0,2.719-2.694v-.123a2.725,2.725,0,0,0-2.71-2.719c-1.487,0-4.852.327-6.866-1.686-1.779-1.779-1.461-5.142-1.461-6.666a2.7,2.7,0,0,0-2.71-2.719h-.123a2.737,2.737,0,0,0-2.736,2.71V247c0,5.845,2.22,7.809,6.495,7.809Z",
    transform: "translate(-219.237 0)",
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M221.713,284.965h-2.839a.613.613,0,0,1-.615-.585V281.8a.613.613,0,0,1,.615-.586h2.839a.587.587,0,0,1,.585.586v2.575A.586.586,0,0,1,221.713,284.965Zm-.088,18.7h-2.693a.613.613,0,0,1-.585-.614V287.746a.587.587,0,0,1,.585-.586h2.693a.587.587,0,0,1,.585.586v15.306A.613.613,0,0,1,221.625,303.666Z",
    transform: "translate(0 -26.443)",
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M245.294,313.054a22.072,22.072,0,0,1-2.809-.205v5.181a.587.587,0,0,1-.586.585h-2.692a.587.587,0,0,1-.586-.585V297.66c0-.439.117-.615.79-.79a24.941,24.941,0,0,1,5.883-.761c4.712,0,7,2.78,7,7.346v2.253C252.289,310.273,250.006,313.054,245.294,313.054Zm3.131-9.6c0-2.4-.614-4.185-3.131-4.185a17.111,17.111,0,0,0-2.809.2v10.214a24.493,24.493,0,0,0,2.809.2c2.517,0,3.131-1.784,3.131-4.185Z",
    transform: "translate(-12.517 -35.597)",
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M290.362,299.387a8.289,8.289,0,0,0-4.039,1.053V312.2a.613.613,0,0,1-.586.614h-2.692a.613.613,0,0,1-.586-.614V296.9a.588.588,0,0,1,.586-.586h2.545a.587.587,0,0,1,.586.586v.614a6.81,6.81,0,0,1,4.185-1.4.586.586,0,0,1,.585.585V298.8A.587.587,0,0,1,290.362,299.387Z",
    transform: "translate(-39.467 -35.597)",
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M315.375,313.054a24.262,24.262,0,0,1-5.238-.585.662.662,0,0,1-.556-.673v-1.756a.487.487,0,0,1,.5-.468h.117c1.405.176,4.038.322,4.917.322,1.815,0,2.077-.614,2.077-1.405,0-.556-.351-.907-1.287-1.492l-4.01-2.458a4.823,4.823,0,0,1-2.458-4.039c0-2.926,1.843-4.39,5.56-4.39a21.7,21.7,0,0,1,5.21.585.639.639,0,0,1,.527.673v1.7c0,.351-.176.556-.468.556h-.118a42.965,42.965,0,0,0-4.829-.352c-1.405,0-2.019.322-2.019,1.229,0,.468.439.761,1.17,1.2l3.834,2.341c2.459,1.492,2.809,2.955,2.809,4.447C321.11,311.034,319.208,313.054,315.375,313.054Z",
    transform: "translate(-56.049 -35.597)",
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(269.667 254.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M358.326,289.127c2.416,0,3.541,1.358,3.541,4.272v10.046a.339.339,0,0,0,.339.339h1.465a.339.339,0,0,0,.338-.339V293.4c0-3.977-1.806-6.079-5.224-6.079a12.557,12.557,0,0,0-4.562.925l-.382.167V281.7a.318.318,0,0,0-.309-.339h-1.526a.318.318,0,0,0-.308.339v21.741a.337.337,0,0,0,.308.339h1.5a.361.361,0,0,0,.339-.339V290.078l.16-.072A12.184,12.184,0,0,1,358.326,289.127Z",
    transform: "translate(-351.697 -281.366)",
    fill: "#5d5c5c"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(286.115 260.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M400.9,296.822c-4.074,0-6.506,2.57-6.506,6.873v2.748c0,5.832,3.621,7.056,6.659,7.056a27.428,27.428,0,0,0,5.414-.515c.358-.067.39-.166.39-.434v-1.038c0-.042,0-.155-.216-.155h-.152a41.623,41.623,0,0,1-5.435.336c-3.124,0-4.518-1.619-4.518-5.25v-.7h10.5c.254,0,.307-.217.307-.4V303.7C407.342,299.327,404.993,296.822,400.9,296.822Zm4.273,7.42h-8.637V303.7c0-4.188,2.374-5.067,4.365-5.067,2.955,0,4.273,1.563,4.273,5.067Z",
    transform: "translate(-394.391 -296.822)",
    fill: "#5d5c5c"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(302.683 260.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M444.484,303.785c-5.033,0-7.086,1.354-7.086,4.674v.367c0,3.863,2.558,4.675,4.7,4.675a8.9,8.9,0,0,0,4.566-1.46l.41-.239v1.146a.339.339,0,0,0,.337.339h1.406a.339.339,0,0,0,.338-.339V302.29c0-3.679-1.859-5.468-5.682-5.468a26.032,26.032,0,0,0-4.687.393c-.415.06-.415.211-.415.312V298.6c0,.116,0,.216.277.216h.153a44.11,44.11,0,0,1,4.672-.244c2.547,0,3.54,1.044,3.54,3.723v1.494Zm-1.863,8.061c-2.16,0-3.081-.912-3.081-3.051v-.367c0-2.442,1.248-3.266,4.945-3.266h2.532v5.352l-.143.077A8.62,8.62,0,0,1,442.621,311.846Z",
    transform: "translate(-437.398 -296.822)",
    fill: "#5d5c5c"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(319.45 254.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M481.2,281.366a.285.285,0,0,0-.277.307v21.772a.313.313,0,0,0,.277.339h1.588c.191,0,.277-.2.277-.339V281.673a.284.284,0,0,0-.277-.307Z",
    transform: "translate(-480.919 -281.366)",
    fill: "#5d5c5c"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(325.283 257.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M496.368,291.237a.272.272,0,0,0-.307.276v.826c0,.061,0,.247.332.278l3.211.364v10.9c0,3.248,1.252,3.82,3.88,3.82a14.616,14.616,0,0,0,1.944-.15c.318-.049.318-.161.318-.25v-1.068c0-.069,0-.155-.369-.155h-1.71c-1.329,0-1.922-.317-1.922-2.2V292.952h3.57a.339.339,0,0,0,.339-.339v-1.039a.339.339,0,0,0-.339-.337h-3.57v-3.6c0-.155-.094-.247-.186-.247h-.091l-1.546.242a.35.35,0,0,0-.319.341v3.266Z",
    transform: "translate(-496.061 -287.389)",
    fill: "#5d5c5c"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(338.355 254.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M536.619,289.127c2.415,0,3.54,1.358,3.54,4.272v10.046a.339.339,0,0,0,.339.339h1.466a.339.339,0,0,0,.338-.339V293.4c0-3.977-1.807-6.079-5.224-6.079a12.56,12.56,0,0,0-4.563.925l-.382.167V281.7a.317.317,0,0,0-.308-.339H530.3a.318.318,0,0,0-.308.339v21.741a.337.337,0,0,0,.308.339h1.5a.361.361,0,0,0,.339-.339V290.078l.16-.072A12.189,12.189,0,0,1,536.619,289.127Z",
    transform: "translate(-529.99 -281.366)",
    fill: "#5d5c5c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIprshealth);
export default __webpack_public_path__ + "static/media/iprshealth.4dfc3cf39d6745f9dbd2dea9fb94dc1c.svg";
export { ForwardRef as ReactComponent };